import {
  DatePicker,
  Select,
  Button,
  Space,
  message
} from 'antd'
import { useState, useEffect } from 'react'
import QueryFormComponent from "../components/queryFormComponent";
import TableComponent from "../components/tableComponent";
import ModalComponent from "./components/modalComponent";
import ShopSelect from '../../../components/BaseInfoSelects/StoreSelectBase'
import AuthComponent from '../../../components/AuthComponent';
import service from "../../../@services";
import DeleteComponent from "../components/deleteComponent";

const { RangePicker } = DatePicker

const HomeMall = () => {

  const [modalVisible, setModalVisible] = useState(false)
  const [defaultValue, setDefaultValue] = useState({})
  const [isInit, setIsInit] = useState(false)
  const [modalTitle, setModalTitle] = useState('')
  const [list, setList] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [deleteVisible, setDeleteVisible] = useState(false)
  const [deleteFormVal, setDeleteFormVal] = useState({})
  const [formVal, setFormVal] = useState({})
  const [modalData, setModalData] = useState({})
  const [pageSetting, setPageSetting] = useState({
    pageIndex: 1,
    pageSize: 20
  })
  // 默认值
  const setDefault = (val) => {
    if (isInit) return
    setIsInit(true)
    setDefaultValue({ storeIds: [val.id] })
  }
  // 查询表单
  const fields = [
    {
      label: '所属门店',
      name: 'storeIds',
      component: <ShopSelect keyVal='id' OnOptionsLoad={setDefault} />
    },
    {
      label: '商品名称',
      name: 'keyword',
      placeholder: '商品名称/编码'
    },
    {
      label: '更新人',
      name: 'operName',
      placeholder: '请输入'
    },
    {
      label: '商品状态',
      name: 'onShelves',
      component: (
        <Select allowClear style={{ width: 200 }}>
          <Select.Option value={null}>全部</Select.Option>
          <Select.Option value={1}>上架</Select.Option>
          <Select.Option value={0}>下架</Select.Option>
          <Select.Option value={2}>紧急下架</Select.Option>
          <Select.Option value={3}>初始</Select.Option>
        </Select>
      )
    },
    {
      label: '更新时间',
      name: 'operTime',
      component: (
        <RangePicker
          showTime
          allowClear
          placeholder={['请选择开始时间', '请选择结束时间']}
        />
      )
    }
  ]
  // 表格头
  const columns = [
    {
      title: '排序',
      dataIndex: 'sort',
      key: 'sort',
      align: 'center'
    },
    {
      title: '商品名称',
      align: 'center',
      render: (row) => {
        return row.productDetail ? row.productDetail.name : null
      }
    },
    {
      title: '编码',
      align: 'center',
      render: (row) => {
        return row.productDetail ? row.productDetail.outProductNo : null
      }
    },
    {
      title: '所属门店',
      dataIndex: 'storeName',
      key: 'storeName',
      align: 'center'
    },
    {
      title: '商品状态',
      align: 'center',
      render: (row) => {
        if (row.productDetail) {
          if (row.productDetail.onlineShelves == 0) {
            return '下架'
          } else if (row.productDetail.onlineShelves == 1) {
            return '上架'
          } else if (row.productDetail.onlineShelves == 2) {
            return '紧急下架'
          } else {
            return '初始'
          }
        } else {
          return null
        }
      }
    },
    {
      title: '更新时间',
      dataIndex: 'operTime',
      key: 'operTime',
      align: 'center'
    },
    {
      title: '更新人',
      dataIndex: 'operName',
      key: 'operName',
      align: 'center'
    },
    {
      title: '操作',
      align: 'center',
      render: (row) => (
        <Space>
          <AuthComponent authKey="/mallPageProduct/list">
            <Button
              type="link"
              onClick={() => handleRecommend('edit', row)}
            >编辑</Button>
            <Button
              type="link"
              onClick={() => handleRecommend('delete', row)}
            >删除</Button>
          </AuthComponent>
        </Space>
      )
    }
  ]
  // 时间格式化
  const format = (val, formatStr = 'YYYY-MM-DD HH:mm:ss') => {
    if (!val) return {}
    val.operTimeStart = val.operTime ? val.operTime[0].format(formatStr) : null
    val.operTimeEnd = val.operTime ? val.operTime[1].format(formatStr) : null
    return { ...val }
  }
  // 列表查询
  const getList = () => {
    setLoading(true)
    const params = Object.assign({}, defaultValue, formVal, pageSetting)
    if (params.operTime) delete params.operTime
    if (!Array.isArray(params.storeIds)) {
      let tem = []
      tem.push(params.storeIds)
      params.storeIds = tem
    }
    service.mallManagement.getProductList(params).then(res => {
      setTotal(res.recordCount)
      setList(res.result)
    }).catch(err => console.log(err)).finally(() => {
      setLoading(false)
    })
  }
  // 查询
  const searchFormFn = (val) => {
    if (val.operTime && val.operTime.length > 0) {
      let formatVal = format(val)
      setFormVal({ ...formatVal })
    } else {
      setFormVal({ ...val })
    }
    setPageSetting({
      pageIndex: 1,
      pageSize: 20
    })
  }
  // 翻页
  const changePage = (val) => {
    setPageSetting(val)
  }
  // 操作合集
  const handleRecommend = (type, val) => {
    if (type === 'delete') {
      // 删除
      setDeleteFormVal(val)
      setDeleteVisible(true)
    } else if (type === 'edit') {
      // 打开编辑
      service.mallManagement.getProductDetail(val.id).then(res => {
        setModalData(res)
      }).catch(err => console.log(err)).finally(() => {
        setLoading(false)
      })
      setModalTitle('编辑推荐')
      setModalVisible(true)
    } else {
      // 打开新增
      setModalTitle('新增推荐')
      setModalVisible(true)
    }
  }
  // 关闭弹窗
  const closeModal = () => setModalVisible(false)
  // 表单提交
  const submitModal = (val) => {
    console.log('商品推荐 submitModal', val);
    if (modalTitle === '新增推荐') {
      service.mallManagement.addProductRecommend(val).then(() => {
        message.success('新增成功')
        setModalVisible(false)
        getList()
      }).catch(err => console.log(err))
    } else {
      service.mallManagement.editProduct(val).then(() => {
        message.success('编辑成功')
        setModalVisible(false)
        getList()
      }).catch(err => console.log(err))
    }
  }
  // 删除
  const deleteFn = (id) => {
    service.mallManagement.deleteProduct(id).then(res => {
      message.success('删除成功')
      setDeleteVisible(false)
      getList()
    }).catch(err => console.log(err))
  }
  // 改变门店
  const changeStoreCallback = () => {
    setModalData({})
  }
  // 商户查询
  const searchFn = async (val) => {
    const res = await service.mallManagement.searchProductCode(val)
    let temData;
    res && res.length > 0 ? temData = res[0] : temData = null
    if (temData) {
      setModalData(temData)
    } else {
      message.error('未查询到数据')
    }
  }

  useEffect(() => {
    isInit && getList()
  }, [isInit, pageSetting])

  return (
    <div className="home-mall">
      <QueryFormComponent
        name="homeMall"
        fields={fields}
        authKey={{ search: '/mallPageProduct/list' }}
        defaultValue={defaultValue}
        onSearch={searchFormFn}
      />
      <TableComponent
        loading={loading}
        columns={columns}
        btnName="新增推荐"
        page={pageSetting}
        total={total}
        list={list}
        authKey={{ search: '/mallPageProduct/list' }}
        addRecommend={() => handleRecommend()}
        changePage={changePage}
      />
      <ModalComponent
        visible={modalVisible}
        title={modalTitle}
        modalData={modalData}
        onCancel={closeModal}
        onOk={submitModal}
        search={searchFn}
        changeStoreCallback={changeStoreCallback}
      />
      <DeleteComponent
        visible={deleteVisible}
        title="提示"
        onCancel={() => setDeleteVisible(false)}
        onOk={(id) => deleteFn(id)}
        formVal={deleteFormVal}
      />
    </div>
  )
}

export default HomeMall